import { rxOpenAlert, rxOpenConfirm, rxOpenPrompt } from './rx_subject'

export const alertFailedEnterRoom = () => {
  rxOpenAlert.next({
    title: '入室エラー',
    message: '入室できませんでした'
  })
}

export const confirmLeaveRoom = onOk => {
  rxOpenConfirm.next({
    title: '退室',
    message: '退室します. よろしいですか?',
    close: result => {
      if (result) {
        onOk()
      }
    }
  })
}

export const confirmShufflePlayers = onOk => {
  rxOpenConfirm.next({
    title: 'ランダム配置',
    message: '解答者をランダムに配置します. よろしいですか?',
    close: result => {
      if (result) {
        onOk()
      }
    }
  })
}

export const promptChat = onOk => {
  rxOpenPrompt.next({
    title: 'チャット',
    inputProps: { maxLength: 1000 },
    close: result => {
      if (result) {
        onOk(result)
      }
    }
  })
}

export const promptBoard = onOk => {
  rxOpenPrompt.next({
    title: 'ボード',
    inputProps: { maxLength: 1000 },
    close: result => {
      if (result) {
        onOk(result)
      }
    }
  })
}

export const promptTeamName = (value, onOk) => {
  rxOpenPrompt.next({
    title: 'チーム名',
    inputProps: { required: true, maxLength: 9 },
    text: value,
    close: result => {
      if (result) {
        onOk(result)
      }
    }
  })
}
